import React from "react";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { X, ScanLine } from "lucide-react";

// Captures serial numbers from a Bluetooth/USB barcode scanner (acts as a keyboard,
// sends the code then Enter) or manual typing. One chip per unit, duplicates blocked.
export function SerialScanCapture({ value = [], onChange, required = null, disabled = false, autoFocus = false, testid = "serial-scan" }) {
  const atMax = required != null && value.length >= required;
  const add = (raw) => {
    const sn = (raw || "").trim();
    if (!sn) return;
    if (value.includes(sn)) { toast.error(`Serial "${sn}" already scanned`); return; }
    if (atMax) { toast.error(`Already scanned ${required} of ${required}`); return; }
    onChange([...value, sn]);
  };
  const onKeyDown = (e) => {
    if (e.key === "Enter") { e.preventDefault(); add(e.target.value); e.target.value = ""; }
  };
  const remove = (sn) => onChange(value.filter((v) => v !== sn));
  const met = required == null || value.length === required;

  return (
    <div className="rounded-lg border border-indigo-100 bg-indigo-50/40 p-2.5" data-testid={testid}>
      <div className="flex items-center gap-2">
        <ScanLine className="w-4 h-4 text-indigo-500 shrink-0" />
        <Input
          placeholder={atMax ? "All units scanned" : "Scan or type serial, press Enter"}
          onKeyDown={onKeyDown}
          disabled={disabled || atMax}
          autoFocus={autoFocus}
          className="bg-white h-8 text-sm"
          data-testid={`${testid}-input`}
        />
      </div>
      {required != null && (
        <div className={`text-[11px] mt-1 font-semibold ${met ? "text-emerald-600" : "text-amber-600"}`} data-testid={`${testid}-count`}>
          {value.length} / {required} serial{required !== 1 ? "s" : ""} scanned
        </div>
      )}
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-2">
          {value.map((sn) => (
            <span key={sn} className="inline-flex items-center gap-1 rounded-full bg-white border border-indigo-200 text-indigo-700 text-xs font-mono px-2 py-1" data-testid={`${testid}-chip`}>
              {sn}
              {!disabled && <button type="button" onClick={() => remove(sn)} className="hover:text-rose-600" data-testid={`${testid}-remove`}><X className="w-3 h-3" /></button>}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export default SerialScanCapture;
